module.exports = __webpack_public_path__ + "img/plan-changed-success.9de365a9.svg";